import React from 'react'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import Typography from 'material-ui/Typography'
import Paper from 'material-ui/Paper'

export const ModalHeader = withStyles(styles)((props) => {
  const { classes, children } = props
  return (
    <div className={classes.header}>
      {children}
    </div>
  )
})

export const ModalContents = withStyles(styles)((props) => {
  const { classes, children } = props
  return (
    <div className={classes.contents}>
      {children}
    </div>
  )
})

export const ModalFooter = withStyles(styles)((props) => {
  const { classes, children } = props
  return (
    <div className={classes.footer}>
      <Typography align="right">
        {children}
      </Typography>
    </div>
  )
})

class DraggableModalFrameBase extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dragOffset: {
        x: 0,
        y: 0
      }
    }
    this.frameRef = React.createRef()
    this.dragStart = null
  }

  getDragPoint = event => {
    if (event.touches && event.touches.length) {
      return event.touches[0]
    }
    return event
  }

  clampDragOffset = (x, y) => {
    const frame = this.frameRef.current
    if (!frame || typeof window === 'undefined') {
      return { x, y }
    }

    const currentOffset = this.state.dragOffset
    const rect = frame.getBoundingClientRect()
    const baseLeft = rect.left - currentOffset.x
    const baseRight = rect.right - currentOffset.x
    const baseTop = rect.top - currentOffset.y
    const baseBottom = rect.bottom - currentOffset.y
    const padding = 16

    return {
      x: Math.min(
        Math.max(x, padding - baseLeft),
        window.innerWidth - padding - baseRight
      ),
      y: Math.min(
        Math.max(y, padding - baseTop),
        window.innerHeight - padding - baseBottom
      )
    }
  }

  startDrag = event => {
    if (event.button && event.button !== 0) {
      return
    }

    if (event.target.closest && event.target.closest('button')) {
      return
    }

    const point = this.getDragPoint(event)
    const { dragOffset } = this.state
    this.dragStart = {
      x: point.clientX - dragOffset.x,
      y: point.clientY - dragOffset.y
    }

    document.addEventListener('mousemove', this.moveDrag)
    document.addEventListener('mouseup', this.stopDrag)
    document.addEventListener('touchmove', this.moveDrag)
    document.addEventListener('touchend', this.stopDrag)
  }

  moveDrag = event => {
    if (!this.dragStart) {
      return
    }

    if (event.cancelable) {
      event.preventDefault()
    }

    const point = this.getDragPoint(event)
    const nextOffset = this.clampDragOffset(
      point.clientX - this.dragStart.x,
      point.clientY - this.dragStart.y
    )

    this.setState({ dragOffset: nextOffset })
  }

  stopDrag = () => {
    this.dragStart = null
    document.removeEventListener('mousemove', this.moveDrag)
    document.removeEventListener('mouseup', this.stopDrag)
    document.removeEventListener('touchmove', this.moveDrag)
    document.removeEventListener('touchend', this.stopDrag)
  }

  componentWillUnmount() {
    this.stopDrag()
  }

  render() {
    const { classes, children, header, paperClassName } = this.props
    const { dragOffset } = this.state

    return (
      <div
        className={classes.draggableModal}
        ref={this.frameRef}
        style={{
          transform: `translate(${dragOffset.x}px, ${dragOffset.y}px)`
        }}
      >
        <Paper className={paperClassName}>
          {header && (
            <div
              className={classes.draggableHeader}
              onMouseDown={this.startDrag}
              onTouchStart={this.startDrag}
            >
              {header}
            </div>
          )}
          {children}
        </Paper>
      </div>
    )
  }
}

export const DraggableModalFrame = withStyles(styles)(DraggableModalFrameBase)
